import axios from 'axios';
import ManageStorage from 'src/shared/global/manageStorage';
import ServiceAuth from '../auth/authToken';
import { useRecoilState } from "recoil";
import { valuesFormReservationUserState } from 'src/Patient/state/atoms';


const agendaApiConfig = axios.create({
    baseURL: process.env.REACT_APP_API_AGENDA
});


agendaApiConfig.interceptors.request.use(
    async config => {
        config.headers = {
            'Authorization': `Bearer ${ManageStorage.getValueFromStorage("token")}`,
        }


         let myURL = ManageStorage.getValueFromStorage("clinica");
         console.log("myURL ==> ", myURL);
         console.log("REACT_APP_SEDE ==> ", process.env.REACT_APP_SEDE);         
         if(myURL != ''){
            if(myURL == "CHILLÁN"){
                myURL = process.env.REACT_APP_CHILLAN;
            }else if(myURL == 'PUERTO MONTT'){
                myURL = process.env.REACT_APP_PUERTO_MONTT;
            }else if(myURL == 'CALAMA'){
                myURL = process.env.REACT_APP_CALAMA;
            }else if(myURL == 'LOS ÁNGELES'){
                myURL = process.env.REACT_APP_CONCEPCION;
            }else if(myURL == 'CONCEPCIÓN'){
                myURL = process.env.REACT_APP_CONCEPCION;
            }else if(myURL == 'TALCA'){
                myURL = process.env.REACT_APP_TALCA;
            }else if(myURL == 'ANCUD'){
                myURL = process.env.REACT_APP_ANCUD;
            }
             config.baseURL = `${myURL}/agenda/api`;
         }
                
        console.log("config.baseURL ==> ", config.baseURL);
        

        return config;
    },
    error => {
        Promise.reject(error)
    });

agendaApiConfig.interceptors.response.use((response) => {
    return response
}, async function (error) {
    const originalRequest = error.config;
    //console.log("ERROR agendaAPI.interceptors => ", error);
    //const [valuesFormReservationUser, setValuesFormReservationUser] = useRecoilState(valuesFormReservationUserState)
    let user = "19"; //valuesFormReservationUser.uswLogin; //JSON.parse(await getUserFromStorage());
    let pass = "Admin123"; //valuesFormReservationUser.uswClave; //await getPassFromStorage();
    console.log(`ERROR agendaAPI.interceptors => RUT ${user.rut} - PASS ${pass} `);
    if (!originalRequest._retry) {
        originalRequest._retry = true;
        // const { data } = await ServiceAuth.authUserGuest({
        //     username: process.env.REACT_APP_USER_GUEST
        // });

        // let user = valuesFormReservationUser.uswLogin; //JSON.parse(await getUserFromStorage());
        // let pass = valuesFormReservationUser.uswClave; //await getPassFromStorage();
        console.log(`ERROR agendaAPI.interceptors => RUT ${user.rut} - PASS ${pass} `);
        const { data } = await ServiceAuth.loginUser({
            "uswLogin": user,
            "uswClave": pass
        });

        console.log("ERROR agendaAPI.interceptors => TOKEN NUEVO => ", data.accessToken);
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.accessToken;
        ManageStorage.setItemStorage("token", data.accessToken);
        return agendaApiConfig(originalRequest);
    }
    return Promise.reject(error);
});

export default agendaApiConfig;